"use strict";

import { NgModule } from "@angular/core";
import { DeferredUrlService } from "./deferred-url.service";

@NgModule({
  providers: [DeferredUrlService]
})
export class DeferredUrlModule {}
